// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-input {\n  border: 1px solid #dddbda;\n  border-radius: 4px;\n  background: #ffffff;\n}\n.color-input .color-input-value {\n  display: inline-block;\n  width: calc(100% - 48px);\n  padding: 0 10px;\n  color: #79797c;\n}\n.color-input .button-selecte-color {\n  display: inline-block;\n  background: #f8f8f8;\n  border-radius: 0px 4px 4px 0px;\n  padding: 5px 10px;\n}\n.color-input .button-selecte-color .pickr {\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
